import { render, staticRenderFns } from "./WorkflowInvocationMetrics.vue?vue&type=template&id=6c597bb6"
import script from "./WorkflowInvocationMetrics.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowInvocationMetrics.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports